import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse une date pure "YYYY-MM-DD" sans décalage timezone.
 * new Date("2026-02-10") interprète en UTC minuit -> en Martinique (UTC-4)
 * ca devient le 9 fevrier. Cette fonction evite ce bug.
 */
export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  if (dateStr.includes("T") || dateStr.includes("Z")) {
    return new Date(dateStr);
  }
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day, 12, 0, 0);
}

/**
 * Formate une date pure "YYYY-MM-DD" en français sans décalage timezone.
 */
export function formatLocalDate(dateStr, options) {
  const opts = options || { day: "numeric", month: "long", year: "numeric" };
  const d = parseLocalDate(dateStr);
  if (!d) return "";
  return d.toLocaleDateString("fr-FR", opts);
}

/**
 * Normalise une chaîne : minuscules + supprime les accents.
 * "Élodie" -> "elodie", "Iléana" -> "ileana"
 */
export function normalize(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, ""); // supprime les diacritiques
}

/**
 * Recherche intelligente multi-mots et sans accent.
 *
 * Chaque mot de la requête doit être présent dans au moins UN des champs.
 * Exemple : "jean mar" matche "Marie Jean" ou "Jean-Marc" ou "jean martin"
 *
 * @param {string} query        - Ce que l'utilisateur a tapé
 * @param {string[]} fields     - Liste des champs dans lesquels chercher
 * @returns {boolean}
 */
export function smartSearch(query, fields) {
  if (!query || !query.trim()) return true;

  // Normaliser et découper la requête en mots (ignore les espaces multiples)
  const words = normalize(query).split(/\s+/).filter(Boolean);

  // Texte combiné de tous les champs (normalisé)
  const haystack = fields
    .map(f => normalize(f || ""))
    .join(" ");

  // Chaque mot doit apparaître quelque part dans le haystack
  return words.every(word => haystack.includes(word));
}
